var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "layout-header" },
    [
      _c("b-container", [
        _c("div", { staticClass: "layout-header--row" }, [
          _c("div", { staticClass: "logo" }, [
            _c("a", { attrs: { href: "/" } }, [
              _c("img", {
                attrs: {
                  src: "/img/logo_claim.svg",
                  alt: "skilldoo - let your skills doo"
                }
              })
            ])
          ]),
          _vm._v(" "),
          !_vm.hideNav
            ? _c(
                "div",
                { staticClass: "layout-header--row-navigations" },
                [
                  _c("nav", { staticClass: "left" }, [
                    _c("ul", [
                      _vm.isNavTypeApplicant
                        ? _c("li", [
                            _c(
                              "a",
                              {
                                attrs: { href: "/info/faq", target: "_blank" }
                              },
                              [_vm._v("FAQs")]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isNavTypeCustomer
                        ? _c("li", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "/info/preise",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Preise")]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isNavTypeCustomer
                        ? _c("li", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "/info/faq-kunde",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("FAQs")]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.authLoaded
                        ? _c("li", [
                            !_vm.isLoggedIn
                              ? _c("a", { attrs: { href: "/auth/login" } }, [
                                  _vm._v("Login")
                                ])
                              : _vm.application
                              ? _c(
                                  "a",
                                  { attrs: { href: "/kandidat/profil/jobs" } },
                                  [_vm._v(_vm._s(_vm.application.firstName))]
                                )
                              : _vm.customer
                              ? _c(
                                  "a",
                                  { attrs: { href: "/kundenbereich/jobs" } },
                                  [_vm._v(_vm._s(_vm.customer.firstName))]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.isNavTypeLogin
                    ? [
                        _vm.isNavTypeApplicant &&
                        _vm.authLoaded &&
                        !_vm.isLoggedIn
                          ? _c("nav", { staticClass: "right" }, [
                              _c("ul", [
                                _c("li", [
                                  _c(
                                    "a",
                                    { attrs: { href: "/mitarbeiterfinden" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\tskilldoo für Arbeitgeber\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("Icon", {
                                        attrs: { icon: "arrow-north-east" }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isNavTypeCustomer &&
                        _vm.authLoaded &&
                        !_vm.isLoggedIn
                          ? _c("nav", { staticClass: "right" }, [
                              _c("ul", [
                                _c("li", [
                                  _c(
                                    "a",
                                    { attrs: { href: "/jobfinden" } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\tskilldoo für Arbeitnehmer\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("Icon", {
                                        attrs: { icon: "arrow-north-east" }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }